import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper and SwiperSlide
import "swiper/css"; // Import Swiper core styles
import "swiper/css/navigation"; // Import Swiper navigation styles
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { useTranslation,Trans  } from 'react-i18next';
import { useEffect, useState } from 'react'
import axios from "axios";

import { endPoints } from "../../Constants";


const Gallery = () => {
    const { t,i18n } = useTranslation();
    const [myImages, setImages] = useState([]);


    useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`${endPoints.gallery}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((res) => {
                setImages(res.data)
                // console.log("MyData========>", myImages);

            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            });
    }, []);
    return (
        <>
            <section className='lyt-section typ-gallery'>
                <div className='container'>


                    <div className='heading-wrapper position-relative z-1 '>
                        <div className=''>
                            <h2 className='bs-heading typwhite typ-32 typ600' data-aos="fade-in" data-aos-delay="200">
                                {t('imageGallery')}
                            </h2>
                        </div>
                    </div>

                    <div className="bs-swiper typ-grsf-logo typ-gallery-swiper">
                        <Swiper
                             modules={[Navigation, Autoplay]} // Enable Navigation module
                            spaceBetween={30}
                            slidesPerView={3}
                            loop={true}
                            autoplay={{
                                    delay: 3000, // Time in milliseconds before the next slide
                                    disableOnInteraction: false, // Keeps autoplay running even after user interaction
                                }}
                            navigation={{
                                prevEl: ".previous",
                                nextEl: ".next",
                            }}
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                },
                                768: {
                                    slidesPerView: 2,
                                },
                                1024: {
                                    slidesPerView: 3,
                                },
                            }}
                            className="swiper-container"
                        >

                            {myImages.map((item, index) => {
                                const { imageHeading, imageDate, imageUrl,imageHeadingMr } = item;

                                return (
                                    <SwiperSlide key={index}>
                                        <div className='bs-card typ-gallery' data-aos="fade-in" data-aos-delay="200">
                                            <div className='box-img'>
                                                <img
                                                    className="img-fluid"
                                                    src={imageUrl}
                                                    alt="Event 1"
                                                    width={384}
                                                    height={297}
                                                />
                                            </div>
                                            <div className='set-contentBox'>
                                                <div className='box-text'>
                                                    <div className='title'>{ i18n.language==='mr'? imageHeadingMr: imageHeading}</div>
                                                    <div className='new-flex'>
                                                        <div>
                                                            <div className='date'>{imageDate}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                )
                            })}


                            {/* <SwiperSlide>

                                <div className='bs-card typ-gallery' data-aos="fade-in" data-aos-delay="200">
                                    <div className='box-img'>
                                        <img
                                            className="img-fluid"
                                            src="/images/home/event/1.jpg"
                                            alt="Event 1"
                                            width={384}
                                            height={297}
                                        />
                                    </div>
                                    <div className='set-contentBox'>
                                        <div className='box-text'>
                                            <div className='title'>Office Interface for Better Work</div>
                                            <div className='new-flex'>
                                                <div>
                                                    <div className='date'>28th Feb, 2025</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='bs-card typ-gallery' data-aos="fade-in" data-aos-delay="200">
                                    <div className='box-img'>
                                        <img
                                            className="img-fluid"
                                            src="/images/home/event/1.jpg"
                                            alt="Event 1"
                                            width={384}
                                            height={297}
                                        />
                                    </div>
                                    <div className='set-contentBox'>
                                        <div className='box-text'>
                                            <div className='title'>We Build Buildings for Future</div>
                                            <div className='new-flex'>
                                                <div>
                                                    <div className='date'>28th Feb, 2025</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='bs-card typ-gallery' data-aos="fade-in" data-aos-delay="200">
                                    <div className='box-img'>
                                        <img
                                            className="img-fluid"
                                            src="/images/home/event/1.jpg"
                                            alt="Event 1"
                                            width={384}
                                            height={297}
                                        />
                                    </div>
                                    <div className='set-contentBox'>
                                        <div className='box-text'>
                                            <div className='title'>Our Service Providers</div>
                                            <div className='new-flex'>
                                                <div>
                                                    <div className='date'>28th Feb, 2025</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>

                                <div className='bs-card typ-gallery' data-aos="fade-in" data-aos-delay="200">
                                    <div className='box-img'>
                                        <img
                                            className="img-fluid"
                                            src="/images/home/event/1.jpg"
                                            alt="Event 1"
                                            width={384}
                                            height={297}
                                        />
                                    </div>
                                    <div className='set-contentBox'>
                                        <div className='box-text'>
                                            <div className='title'>Office Interface for Better Work</div>
                                            <div className='new-flex'>
                                                <div>
                                                    <div className='date'>28th Feb, 2025</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='bs-card typ-gallery' data-aos="fade-in" data-aos-delay="200">
                                    <div className='box-img'>
                                        <img
                                            className="img-fluid"
                                            src="/images/home/event/1.jpg"
                                            alt="Event 1"
                                            width={384}
                                            height={297}
                                        />
                                    </div>
                                    <div className='set-contentBox'>
                                        <div className='box-text'>
                                            <div className='title'>We Build Buildings for Future</div>
                                            <div className='new-flex'>
                                                <div>
                                                    <div className='date'>28th Feb, 2025</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide> */}

                        </Swiper>

                        <div className="swiper-button-prev previous">
                            <span className="icon icon-right-arrow"></span>
                        </div>
                        <div className="swiper-button-next next">
                            <span className="icon icon-right-arrow"></span>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Gallery